import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import moment from 'moment-timezone'
import { fetchCandidate } from 'interview/actions/candidate'
import { mapLanguageToPageProps } from 'interview/i18n'
import FetchWithSpinner from 'components/fetch-with-spinner'
import { formatDateTime } from 'utils/date'
import GenericLayout from 'interview/components/layout/generic-layout'
import { Flex } from 'components/styled/containers/flex'
import { Body, H3 } from 'components/styled/typography'

const propTypes = {
  i18n: PropTypes.shape({
    finished: PropTypes.shape({
      descriptionsupport: PropTypes.func,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  params: PropTypes.shape({
    context: PropTypes.string.isRequied,
    token: PropTypes.string.isRequired,
  }).isRequired,
  candidate: PropTypes.shape({}),
  dispatch: PropTypes.func.isRequired,
}

const defaultProps = {
  candidate: undefined,
}

const mapStateToProps = state => ({
  candidate: state.candidate,
})

export class Unpublished extends Component {
  componentDidUpdate(prevProps) {
    const {
      candidate,
      params: { context, token },
      dispatch,
    } = this.props

    if (candidate !== prevProps.candidate) {
      const publishTime =
        candidate && candidate.opening && candidate.opening.publishTime
      if (moment(publishTime) < moment()) {
        const path = context === 'sequenced-interview' ? context : 'enter'
        dispatch(replace(`/${path}/${token}`))
      }
    }
  }

  render() {
    const {
      i18n,
      candidate,
      params,
      location: { pathname },
    } = this.props
    const publishTime =
      candidate && candidate.opening && candidate.opening.publishTime

    return (
      <FetchWithSpinner
        action={() => fetchCandidate(params, params.context, pathname)}
      >
        <GenericLayout>
          <Flex
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            py="s24"
          >
            <H3>{i18n.unpublished.title}</H3>
            {publishTime && (
              <Body>
                {i18n.unpublished.publishTime(formatDateTime(publishTime))}
              </Body>
            )}
          </Flex>
        </GenericLayout>
      </FetchWithSpinner>
    )
  }
}

Unpublished.propTypes = propTypes
Unpublished.defaultProps = defaultProps

export default connect(mapLanguageToPageProps(mapStateToProps))(Unpublished)
